



































import Vue from 'vue'
import { GChart } from 'vue-google-charts'

export default Vue.extend({
  components: {
    GChart,
  },
  props: ['id'],
  data: () => ({
    showDatePicker: false,
    dates: [] as string[],
    uploadData: [] as any[],
    chartOptions: {
      legend: 'none',
      curveType: 'function',
      lineWidth: 2,
      vAxis: {
        title: '# of Uploads',
        viewWindow: { min: 0 },
      },
      hAxis: { title: 'Day' },
    },
  }),
  created() {
    this.loadDefaultDates()
    this.loadUploadStatistics()
  },
  computed: {
    chartData(): [[string]] {
      return <[[string]]>this.getLabelsAndValues([['Day', 'Uploads']])
    },
    dateRangeText(): string {
      return this.sortedDates.join(' ~ ')
    },
    sortedDates(): string[] {
      return this.dates.sort()
    },
  },
  methods: {
    async loadUploadStatistics() {
      try {
        let res = await this.$axios.get(
          `clinical-trial/${this.id}/upload/stats`
        )
        this.uploadData = res.data
      } catch (e) {
        this.$toast.error('Failed to load upload statistic data')
      }
    },
    loadDefaultDates() {
      // load default one week value
      let today = new Date()
      let currDate = new Date()
      // Curr date 6 days ago so that we can get a week of data
      currDate.setDate(currDate.getDate() - 6)
      this.dates.push(
        currDate.toLocaleString('en-ca', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
      )
      this.dates.push(
        today.toLocaleString('en-ca', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
      )
    },
    getLabelsAndValues(chartData: [string[]]) {
      let start = new Date(this.sortedDates[0])
      start.setDate(start.getDate() + 1)
      let end = new Date(this.sortedDates[1])
      end.setDate(end.getDate() + 1)
      for (start; start <= end; start.setDate(start.getDate() + 1)) {
        const row = []
        // Check if we have data for currDate
        row.push(start.toDateString().substring(4, 10)) // Get only the month and date
        let matches = this.uploadData.filter((uploadEvent) => {
          return (
            start.getDate() === new Date(uploadEvent.createdDate).getDate() + 1
          ) // Add one because JS Dates give days that are 1 day behind 🙃
        })

        // If we have data, use the data value, or else use 0
        if (matches.length > 0) {
          row.push(matches[0].numFilesUploaded)
        } else {
          row.push(0)
        }
        chartData.push(row)
      }
      return chartData
    },
  },
})
